import { useState } from "react"

import ConfirmationModal, {
  ModalInfo,
} from "components/Modals/ConfirmationModal"
import { Container, Header } from "components/Page"

import { ReactComponent as AgenciesIcon } from "assets/icon-companies.svg"
import Breadcrumbs from "components/Breadcrumbs"
import { Client } from "models/common"
import { EmptyState } from "components/EmptyState"
import Surface from "components/Surface"
import { Table } from "components/tables"
import { columns } from "./columns"
import { css } from "@emotion/css"
import { fetchClients } from "api/clients"
import { limitAndOffset } from "api/utils"
import { useI18n } from "providers/I18n"
import { useLocationSearch } from "hooks/useLocationSearch"
import { useQuery } from "react-query"

export function MarketClientsList() {
  const { t } = useI18n()
  const ls = useLocationSearch()
  const [modalInfo, setModalInfo] = useState<ModalInfo>()

  const params = ls.map(limitAndOffset).toString()

  const q = useQuery(["clients", params], fetchClients)
  const { status, data } = q
  const clients = data?.data

  const isModalOpen = Boolean(modalInfo)
  const total = data?.total

  return (
    <>
      <div>
        <Container>
          <Breadcrumbs
            section={t("nav.admin")}
            current={t("nav.market.clients")}
          />
          <Header label={t("nav.market.clients")} />
          <Surface className={styles.surface}>
            <Table<Client>
              id="marketClients-list-table"
              columns={columns()}
              data={clients ?? []}
              filters={[]}
              total={total ?? 0}
              loading={status === "loading"}
              searchBy="search"
              noResults={
                <EmptyState
                  title={t("clients.noresults.title")}
                  icon={<AgenciesIcon />}
                />
              }
            />
          </Surface>
        </Container>
      </div>
      <ConfirmationModal
        open={isModalOpen}
        onCancel={() => setModalInfo(undefined)}
        {...modalInfo}
      />
    </>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) var(--spacing-m) var(--spacing-m);
  `,
}
